import React, { useState } from "react";
import axiosInstance from "../../../axios";
import "./pricingPlan.scss";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const PricingPlan = ({ buttonText }) => {
  const [isActive, setIsActive] = useState(undefined);
  const [email, setEmail] = useState("");
  const [response, setResponse] = useState({ success: false });
  const handleOnClick = async () => {
    if (isActive && buttonText !== "Know More") {
      try {
        const data = await axiosInstance.post(
          `${REACT_APP_LOGIN_API_BASEURL}/user/linguisity?email=${email}`
        );
        setResponse((state) => ({ ...state, success: !data.error }));
      } catch (error) {
        setResponse(error);
      }
    }

    if (buttonText === "Know More") {
      window.location.href = "/languisity";
    }
  };

  const handleChange = (event) => {
    setEmail(event.target.value);
  };

  if (response.success) {
    return (
      <div className="plans-container">
        <div className="footer-container">
          <div className="subscribe response">
            <div>Thank you. Someone from our team will reach out to you!</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="plans-container">
      {/* <ul>
        {plans.map((plan, index) => (
          <li className={`plan-item ${index === 1 ? "selected" : ""}`}>
            <span className="plan-price">$500</span>
            <span className="plan-description">One time + Per Account</span>
          </li>
        ))}
      </ul> */}
      <div className="footer-container">
        <input
          name="email"
          type="text"
          className={`addons-input ${isActive && buttonText === "Notify Me" ? "active" : ""
            }`}
          placeholder="Enter your email"
          onChange={handleChange}
        />
        <button
          className={`addons-submit ${isActive && buttonText === "Notify Me" ? "active" : ""
            }`}
          type="button"
          // onClick={() =>
          //   isActive && buttonText === "Notify Me" ? null : setIsActive(true)
          // }
          onClick={
            buttonText === "Notify Me" && typeof isActive === "undefined"
              ? () => setIsActive(true)
              : handleOnClick
          }
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default PricingPlan;
